import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './CompanyDetailsIncorrect.messages';

export const CompanyDetailsIncorrect = () => {
    return (
        <div className="content-text" data-testid="error-details-text">
            <FormattedMessage {...messages.message} />
        </div>
    );
};
